export default __webpack_public_path__ + "static/media/docker.dc0d9ade.png";